export default __webpack_public_path__ + "static/media/Winter_23.8a918bc0.png";